import React from 'react'
import { Badge, TakeAways, LazyLoad, SeoHelmet } from '../../common/Functions'
import Roles from './roles'
import Ecosystem from './ecosystem'
import Branding from './branding'

function Drapshop() {
  return (
   <div id="works">
    <SeoHelmet title="Drapshop" description="An online ordering and delivery system for customers, restaurants/grocery store owners, and drivers." />
    <section className="banner drapshop px-0">
      <div className="max-w-screen-xl	mx-auto">
        <main className="mt-10">
          <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
            <div className="lg:w-7/12 md:w-full inline-flex lg:justify-end ml-5 lg:ml-0 mt-10">
              <div className="content">
                <h1 className="text-left font-bold text-3xl text-white">
                  An online ordering and delivery system for customers, restaurants/grocery store owners, and drivers.
                </h1>
                <p className="text-white mt-10">
                  Check how I help design the online ordering and delivery system.
                </p>
                <div className="roles mt-20">
                  <Badge title="UX/UI Design" />
                  <Badge title="Branding" />
                  <Badge title="Web & Mobile Application" />
                </div>
              </div>
            </div>
            <div className="lg:w-5/12 md:w-full sm:order-first md:order-first lg:order-last flex items-center justify-center">
              <LazyLoad className="inline" src={require('../../common/images/home/drapshop.svg')} alt="Drapshop Logo"/>
            </div>
          </div>
        </main>
      </div>
      </section>
      <Roles />
      <Ecosystem />
      <Branding />
      <TakeAways content="I'm also fond of using online ordering food applications, and so I'm very familiar with how the system works. This project is one of the exciting designs that I worked on because I get a chance to create my creative assets. Form the image banners that I selected to use, up to vector graphics in each step of the ordering process. It is an excellent opportunity to enhance my skills in creating photo manipulations and vector art." />
   </div>
  )
}

export default Drapshop
